import React, { useMemo } from 'react';
import {
  Col, Form, FormItemProps, Input, Row, Select, Switch,
} from 'antd';
import { enumToOptionsArray } from '../../../../utils';
import { UserRole, UserRoleDisplay } from '../../../../enums/user';
import { useAuth } from '../../../../store/auth';
import { UserCreateParams } from '../../../../hooks/api/users';
import {
  createRulesForAntd,
  validationSignInEmailAndPassword,
} from '../../../../utils/validations';

const validationRules = createRulesForAntd(validationSignInEmailAndPassword);

function AdminFormItems({
  data, variant = 'create', editedUserId,
}: { data?: Partial<UserCreateParams>, variant: 'create' | 'update', editedUserId?: string }) {
  const { user } = useAuth();
  const isEditingSelf = variant === 'update' && !!editedUserId && user?.id === editedUserId;
  const isRoleDisabled = isEditingSelf && user?.role === UserRole.ROOT;

  const formItems: (FormItemProps & { element: React.ReactNode, colSpan?: number })[] = useMemo(() => [
    {
      name: 'firstName',
      label: 'First Name',
      element: <Input placeholder="Enter" />,
    },
    {
      name: 'lastName',
      label: 'Last Name',
      element: <Input placeholder="Enter" />,
    },
    /*
    {
      name: 'dateOfBirth',
      label: 'Date of birth',
      rules: [{ required: true }],
      element: <DatePicker format={dateFormat} style={{ width: '100%' }} />,
    },
    {
      name: 'phone',
      label: 'Phone',
      element: <AlternativePhoneInput />,
    },
    */
    {
      name: 'email',
      label: 'Email',
      rules: [{ required: true }, validationRules],
      element: <Input placeholder="Enter" autoComplete="off" disabled={variant === 'update'} />,
    },
    {
      name: 'password',
      label: 'Password',
      rules: [{ required: true }, validationRules],
      element: <Input.Password placeholder="Enter" autoComplete="new-password" />,
    },
    {
      name: 'role',
      label: 'Role',
      rules: [{ required: true }],
      element: <Select
        placeholder="Select"
        options={enumToOptionsArray(UserRoleDisplay)
          .filter((option) => ['editor', 'mitarbeiter', 'admin', 'root'].includes(option.value))}
        disabled={isRoleDisabled}
      />,
    },
    {
      name: 'isTwoFAActive',
      label: 'Is 2FA Enabled',
      element: <Switch checkedChildren="Yes" unCheckedChildren="No" />,
    },
    {
      name: 'status',
      label: 'status',
      rules: [{ required: false }],
      style: { display: 'none' },
      element: <Input />,
    },
  ]
    /** If variant is 'create' - don't show these fields */
    .filter((item) => (variant === 'create'
      ? !['isTwoFAActive'].includes(item.name as string)
      : true))
    /** If variant is 'update' - don't show these. */
    .filter((item) => (variant === 'update'
    // 'email',
      ? !['password'].includes(item.name as string)
      : true)), [data, isRoleDisabled]);

  return (
    <div>
      <Row gutter={12}>
        {formItems.map(({
          element, colSpan, name, rules, ...formItemProps
        }) => (
          <Col key={name} span={colSpan || 12}>
            <Form.Item name={name} {...formItemProps} rules={[...(rules || [])]}>
              {/* validationRules */}
              {element}
            </Form.Item>
          </Col>
        ))}
        {/* <Col span={12} /> */}
      </Row>
    </div>
  );
}

export default AdminFormItems;
